var track = require('client/lib/analytics').track

module.exports = {
  'track-share': function () {
    var $this = $(this)
    var shareType = $this.attr('data-share-type')
    var actionedObjectType = $this.attr('data-actioned-object-type')
    var payload = {
      type: shareType,
      metabase: {
        'actioned_object_type': actionedObjectType,
        'extra_properties': shareType
      }
    }
    switch (actionedObjectType) {
      case 'mix':
        var mixId = $this.attr('data-mix-id')
        payload['mix_id'] = mixId
        payload.metabase['actioned_object_id'] = mixId
        break
      case 'url_id':
        var urlId = $this.attr('data-url-id')
        payload['url_id'] = urlId
        payload.metabase['actioned_object_id'] = urlId
        break
      default:
        throw Error('Invalid actioned_object_id for track-share')
    }
    track('share-external', payload)
  },

  'track-click': function () {
    var $this = $(this)
    var trackEvent = $this.attr('data-track-event')
    var trackData
    try {
      trackData = JSON.parse($this.attr('data-track-data'))
    } catch (exception) {
      // do nothing
    }
    track(trackEvent, trackData)
  }
}
